export default [
  {
      field: 'invoice_type',
      type: 'text',
      value: '',
      vuetifyProps: {
          label: 'Tipo Documento',
      },
  },
  {
      field: 'invoice_number',
      type: 'text',
      value: '',
      vuetifyProps: {
          label: 'Folio Documento',
      },
  },
  {
    field: 'reference_document',
    type: 'text',
    value: '',
    vuetifyProps: {
      label: 'Documento REF',
    },
  },
  {
    field: 'number_reference_document',
    type: 'text',
    value: '',
    vuetifyProps: {
      label: 'Folio REF',
    },
  },
  {
      field: 'net_total',
      type: 'text',
      value: '',
      vuetifyProps: {
          label: 'Neto',
      },
  },
  {
      field: 'iva',
      type: 'text',
      value: '',
      vuetifyProps: {
          label: 'IVA',
      },
  },
  {
      field: 'total',
      type: 'text',
      value: '',
      vuetifyProps: {
          label: 'Total',
      },
  },
  {
      field: 'global_discount_percentage',
      type: 'text',
      value: '',
      vuetifyProps: {
          label: '(%) Dto. Global',
      },
  },
  {
      field: 'global_discount_amount',
      type: 'text',
      value: '',
      vuetifyProps: {
          label: '($) Dto. Global',
      },
  },
  {
    field: 'reason',
    type: 'text',
    value: '',
    vuetifyProps: {
        label: 'Motivo',
    },
},
]
